module.exports = __webpack_public_path__ + "89af3cd1742d1bd8f4c81d77cd43afbb.png";